import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

import { Button } from "scmp-app/components/common/button";
import { ContentBody } from "scmp-app/components/content/content-body";
import { ContentHeadline } from "scmp-app/components/content/content-headline";
import { StyledDiv as StyledParagraphDiv } from "scmp-app/components/schema-render/common/paragraph/styles";

import ImagePlaceholder from "./img-placeholder.svg";

export const StyledContentBody = styled(ContentBody)`
  max-block-size: 436px;

  overflow: hidden;

  && {
    font-weight: 400;
    font-size: 18px;
    font-family: ${fontRobotoCondensed};
    line-height: 130%;

    ${StyledParagraphDiv} {
      margin-block-end: 20px;

      overflow-wrap: anywhere;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-block: 8px;

      font-weight: 700;
      font-size: 16px;
      font-family: ${fontRobotoCondensed};
      line-height: normal;
    }

    p {
      margin-block: 0 20px;
    }

    ol {
      padding-inline: 20px;

      list-style: decimal;
    }

    ul {
      margin-block: 0 20px;
      margin-inline-start: 20px;

      list-style: disc;
    }

    li {
      padding-block-end: 0;
      padding-inline-start: 2px;

      &:not(:last-child) {
        padding-block-end: 20px;
      }
      * {
        margin: 0 !important;
      }
    }

    strong {
      font-weight: bold;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  font-family: ${fontRobotoCondensed};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  padding-block: 28px 32px;
  padding-inline: 28px;

  color: #000000;

  background-color: #d3dff2;

  border-start-end-radius: 12px;
  border-start-start-radius: 12px;
`;

export const StyledContentHeadline = styled(ContentHeadline)`
  font-weight: 700;
  font-size: 28px;
  line-height: 33px;
`;

export const Heading = styled.div`
  font-weight: 700;
  font-size: 14px;
`;

export const PublishedContainer = styled.div``;
export const PublishedDate = styled.span`
  font-weight: 700;
  font-size: 14px;
`;

export const ContentContainer = styled.div`
  margin-block-start: 2px;
  padding-block: 20px 28px;
  padding-inline: 28px;

  color: #000000;

  background-color: #d3dff2;

  border-end-end-radius: 12px;
  border-end-start-radius: 12px;
`;

export const Content = styled.div`
  position: relative;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-block-start: 32px;

  ${theme.breakpoints.only("desktop")} {
    flex-direction: column;
    gap: 16px;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const ReadFullDailyPulseButton = styled(Button)`
  inline-size: 182px;
  padding-block: 8px;
  padding-inline: 12px;

  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  line-height: 20.8px;

  border-radius: 2px;

  background: #4585ff;
`;

export const PreviousEditions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  color: #4585ff;
  font-weight: 700;
  font-size: 16px;

  cursor: pointer;

  text-decoration-line: underline;
`;

export const PlaceHolderContainer = styled.div``;

export const StyledImagePlaceholder = styled(ImagePlaceholder)``;

export const ContentOverlayer = styled.div`
  position: absolute;
  inset-block-end: 0;

  inline-size: 100%;
  block-size: 80px;

  background: linear-gradient(180deg, rgba(211, 223, 242, 0) 0%, #d3dff2 81.5%);
`;
